import { mapGetters, mapState } from 'vuex';
import featureFlagSlugs from '@/constants/featureFlagSlugs';

const computed = {
  ...mapGetters([
    'isAuthorized',
  ]),
  ...mapState({
    featureFlagsStore: 'featureFlags',
  }),
  featureFlags() {
    return this.featureFlagsStore.flags;
  },
};

const data = () => ({
  featureFlagSlugs,
});
const watch = {
  isAuthorized(authorized) {
    if (
      this.$route.name !== 'logout'
      && authorized === true
    ) {
      this.$store.dispatch('getAllFeatureFlags');
    }
  },
};

export default {
  computed,
  data,
  watch,
};
